/**
 *
 * @file 模板更换里
 *
 **/

import { makeAutoObservable } from 'mobx';

class TemplateManage {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    expandStageIds = [];

    setExpandStageIds(arr) {
        this.expandStageIds = arr;
    }

    get hasIds() {
        return !!this.expandStageIds.length;
    }
}

export default new TemplateManage();
